import { render, staticRenderFns } from "./link-geotab-driver-form.vue?vue&type=template&id=a4f59fea&"
import script from "./link-geotab-driver-form.vue?vue&type=script&lang=js&"
export * from "./link-geotab-driver-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports